module.exports = __webpack_public_path__ + "img/choose.07ac2dd7.png";